<template>
  <div class="page-content conmon-top">
      <div>
          <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">{{ hide? '收起查询':'展开查询' }}</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="getData">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-flod-content common-search-formtype" style="padding: 0 0 4px 0">
            <el-form :inline="true" :model="formInline" class="search-content-item" label-width="100px">
              <el-form-item label="订单编号:">
                <el-input v-model="formInline.order_num" placeholder="请输入订单编号" clearable></el-input>
              </el-form-item>
              <el-form-item label="订单时间:">
                <el-date-picker style=""
                  v-model="formInline.create_time"
                  type="date"
                  placeholder="订单时间"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="会员编号:">
                <el-input v-model="formInline.vip_card" placeholder="请输入会员编号" clearable></el-input>
              </el-form-item>
              <el-form-item label="会员姓名:">
                <el-input v-model="formInline.truename" placeholder="请输入会员姓名" clearable></el-input>
              </el-form-item>
              <el-form-item label="收货人:">
                <el-input v-model="formInline.consignee_name" placeholder="请输入收货人姓名" clearable></el-input>
              </el-form-item>
              <el-form-item label="收货电话:">
                <el-input v-model="formInline.consignee_number" placeholder="请输入收货人电话" clearable></el-input>
              </el-form-item>
              <el-form-item label="状态:">
                <el-select v-model="formInline.status" placeholder="请选择状态">
                  <el-option
                    v-for="item in orderStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
          <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="exporeAction" class="add-btn" style="float: right;">导出</el-button>
      </el-col>
    </el-row>
          <el-row class="import-data-title">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table">
        <el-table-column
          prop="order_num"
          label="订单编号"
          width="">
        </el-table-column>
        <el-table-column
          prop="vip_card"
          label="会员编号"
          width="">
        </el-table-column>
        <el-table-column
          prop="realname"
          label="会员姓名">
        </el-table-column>
        <el-table-column
          prop="grade_name"
          label="会员等级">
        </el-table-column>
        <el-table-column
          prop="in_title"
          label="权益名称">
        </el-table-column>
        <el-table-column
          prop="in_gift_name"
          label="奖品">
        </el-table-column>
        <el-table-column
          prop="consignee_name"
          label="收货人">
        </el-table-column>
        <el-table-column
          prop="consignee_number"
          width="110"
          label="收货电话">
        </el-table-column>
        <el-table-column
          prop=""
          label="收货地址">
          <template slot-scope="scope">
            <span>{{ scope.row.consignee_province }}- {{ scope.row.consignee_city }}-{{ scope.row.consignee_county }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1">
              未发货
            </div>
            <div v-if="scope.row.status === 2">
              已发货
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="" style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link" v-if="scope.row.status === 1">
              <!-- <i class="iconfont icon-icon-bianji" style="font-size: 14px"></i> -->
              <span @click="changeInterestStatus(scope.row.id)">发货</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
      </div>
  </div>
</template>
<script>
import { getMemberInterestOrderList, changeMemberInstrestOrderStatus, exportMemberInterestOrder } from '@/api/customer.js'
export default {
  name: 'importData',
  data () {
    return {
      formInline: {
        order_num: '',
        create_time: '',
        vip_card: '',
        truename: '',
        consignee_name: '',
        consignee_number: '',
        status: ''
      },
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      orderStatusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未发货',
          value: '1'
        },
        {
          label: '已发货',
          value: '2'
        }
      ],
      memberLevelList: {}
    }
  },
  methods: {
    exporeAction() {
      exportMemberInterestOrder(this.formInline).then(res => {
        this.download(res)
      })
    },
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    changeInterestStatus(id) {
      this.$confirm('确认发货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeMemberInstrestOrderStatus(id, '2').then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.getData()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      if (this.formInline.consignee_number !== '') {
        let mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/
        if (!mobile.test(this.formInline.consignee_number)) {
          _g.toastMsg('error', '请填入正确手机号')
          return
        }
      }
      getMemberInterestOrderList(this.page, this.formInline).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    }
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
